import { Document } from '@react-pdf/renderer';
import { QuotePdfType } from '@snap-types/models/enums';

import { PDFProvider, PDFProviderType } from './PDFProvider';
import { siteQuoteDocuments } from './SiteQuoteDocuments';

type PDFDocumentProps = PDFProviderType & {
  quotePdfType: QuotePdfType;
};

export function PDFDocument({ quotePdfType, ...props }: PDFDocumentProps) {
  const QuoteDocument = siteQuoteDocuments[quotePdfType];

  return (
    <Document>
      <PDFProvider {...props}>
        <QuoteDocument />
      </PDFProvider>
    </Document>
  );
}
